// src/Login.js
import React, {useEffect} from 'react';
import { useMsal } from '@azure/msal-react';
import {
  loginRequest, TOKEN_REQUEST, initializeMsal} from '../auth/msalConfig';
import { useNavigate } from 'react-router-dom';  
import { useState } from 'react';
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import Typewriter from "typewriter-effect";
import '@styles/Login.css';
import "@fontsource/quicksand"

document.body.style = 'background: #FEF8F1';

const Login = () => {
  const  {instance, accounts}  = useMsal();
  const navigate = useNavigate();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const checkAccount = async () => {

      const activeAccount = instance.getActiveAccount();  // Check if there is an active account
      if (!activeAccount && accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);  // Set the first account as the active account
      }

      if (instance.getActiveAccount()) {
        // Try to acquire a token silently
        try {
          const tokenResponse = await instance.acquireTokenSilent(TOKEN_REQUEST);
          setToken(tokenResponse.accessToken);
          navigate('/chat');  // Navigate to chat if the token is successfully acquired
        } catch (error) {
          console.error('Silent token acquisition failed:', error);
        }
      }
    };

    checkAccount();
  }, [instance, accounts, navigate]);
  
  const handleLogin = async () => {
    try {

      const loginResponse = await instance.loginPopup(loginRequest);
      const email = loginResponse.account.username;  
      
      if (email.endsWith('@student.vu.nl') || email.endsWith('@vu.nl')) {
        
        try {
          const tokenResponse = await instance.acquireTokenSilent(TOKEN_REQUEST);
          const accessToken = tokenResponse.accessToken;

          console.log('Access Token:', accessToken);

          navigate('/chat');
        } catch (tokenError) {
          if (tokenError instanceof InteractionRequiredAuthError) {
            try {
              const tokenResponse = await instance.acquireTokenPopup(TOKEN_REQUEST);
              const accessToken = tokenResponse.accessToken;
              console.log('Access Token (popup):', accessToken);
              navigate('/chat');
            } catch (popupError) {
              console.error('Token acquisition via popup failed:', popupError);
            }
          } else {
            console.error('Silent token acquisition failed:', tokenError);
          }
        }
      } else {
        // If the email is not from the required domain, log out the user
        alert('Access restricted to VU Amsterdam students only.');
        await instance.logoutPopup();
      }
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div>
    <div className="container mt-5" style={{paddingBottom: 20}}>
      
      <div className="d-flex justify-content-between">
        <a href="https://vu.nl/nl" style={{width: "20%"}}>
          <img src="VU-logo-RGB.png" alt="VU Logo" style={{width: 250}} />
        </a>
        <button className="btn btn-outline-primary m-3" onClick={handleLogin}>
          <i className="bi bi-box-arrow-in-right"></i> Log In
        </button>
      
      </div>
      <div style={{marginBottom: '0', paddingBottom: 0, justifyContent: 'center', alignItems: 'center', textAlign: 'center', paddingBottom: 2}}>
        <img src="/rolo-cut.jpg" alt="Icon" style={{ width : 200}} />
      </div>
      
      <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#0E2F46', display: 'flex', flexDirection: 'row', width: '30%', margin: '0 auto', position: 'relative', left: 105}}>
        <div>To help you</div> 
        <div>&nbsp;</div>
        <div>
          <b>
            <Typewriter
              options={{
                strings: ["Study", "Plan", "Brainstorm", "Code", "Practice", "Learn", "Revise", "Solve", "Understand", "Prepare", "Teach", "Discuss", "Analyze", "Create", "Excel"],
                autoStart: true,
                loop: true,
                delay: 100,
                deleteSpeed: 100,
                
              }}
            />
            </b>
          </div>
        </div>
      
        
        <div style={{fontFamily:'Quicksand', fontSize: 50, color: '#0E2F46', marginTop: 50}}>
          <b>What is Rolo?</b>
        </div>

        <div style={{width: '100%', justifyContent: 'left', alignItems: 'left', textAlign: 'left', width: '75%'}}>
          <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#0E2F46', marginTop: 20}}>
            Programming is complicated, and students often need a lot of help when learning how to code. Professors and teaching assistants are often unable to provide everyone with the personalized help they might need. Rolo Tutor is designed as a teaching assistant available to students at all hours of the day, outside of the classroom.
          </div>
        </div>

      
      <div style={{fontFamily:'Quicksand', fontSize: 50, color: '#0E2F46', textAlign: 'right', marginTop: 50}}>
        <b>Designed to Teach, not Answer</b>
      </div>
      <div style={{width: '100%', justifyContent: 'right', alignItems: 'right', textAlign: 'right'}}>
          <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#0E2F46', marginTop: 20, width: '75%', transform: 'translateX(33%)'}}>
          Many chatbots are designed to simply provide answers to questions, but Rolo Tutor is designed to teach. Rolo Tutor guides students through the process of solving a problem, helping them understand the concepts behind the code. As such, Rolo Tutor is not meant to do work for students, but to help them learn how to do the work themselves.
        </div>
      </div>

      
      <div className="text-center" style={{marginTop: 85, marginBottom: 20}}>
        <button className="btn border border-dark" onClick={handleLogin} style={{backgroundColor: '#0E2F46', color: '#FEF8F1', borderRadius: 10,  fontSize: 20}}>
        Sign in with VU email
        </button>
      </div>

      {/* footer*/}
      

      

      
      {/* Navigate to some URL for the exam" */}
      {/* <div className="exam-mode" onClick={() => navigate('/exam_mode')}>
      <Typewriter
          options={{
            strings: ["Do you have an exam?"],
            autoStart: true,
            loop: true,
            delay: 50,
          }}
        />
      </div> */}
    </div>

    <div style={{width: '100%',
        backgroundColor: '#0E2F46',
        margin: 0,
        padding: 0,
        position: 'relative',
        bottom: 0,
      }}>
        <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#FEF8F1', paddingTop: 10, textAlign: 'center'}}>
          <b>Developed at Vrije Universiteit Amsterdam</b>
        </div>
        <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#FEF8F1', marginTop: 10, textAlign: 'center'}}>
          <b>m.verano.merino@vu.nl</b>
        </div>
        <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#FEF8F1', marginTop: 10, textAlign: 'center'}}>
          <b>Version 1.0</b>
        </div>
        <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#FEF8F1', marginTop: 10, textAlign: 'center'}}>
          <b>Privacy Policy</b>
        </div>
        <div style={{fontFamily:'Quicksand', fontSize: 20, color: '#FEF8F1', marginTop: 10, textAlign: 'center', paddingBottom: 10}}>
          <b>Terms of Service</b>
        </div>
      </div>
  </div>
  );
};

export default Login;

// import React from "react";
// import { login } from "./auth";

// const Login = () => {
//   return (
//     <div className="container text-center mt-5">
//       <h2>Welcome to the Rolo Tutor</h2>
//       <p>Log in to continue.</p>
//       <button className="btn btn-primary" onClick={login}>
//         Log in with Connect ID
//       </button>
//     </div>
//   );
// };

// export default Login;

